export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Order Timeout",
      "649f8aefc1c0": "Recycling Failed",
      "649f8aefc9c0": "Get a New Quote",
      "TradeIn": "Trade-in process",
      "logistic": 'Download shipping label',
      "start": "Start Journey",
      "success": "You have successfully signed for the new machine",
      "qc": "Old Device QC",
      "business": "We will complete your old device inspection within 3 working days",
      "completed": "Completed",
      "successfully": "Congratulations your trade-in are successfully",
      "orderInfor": "Order information",
      "orderID": "Trade-in Order ID",
      "orderNum": "New device purchase order ID",
      "createTime": "Creation time",
      "brand": "Estimated brand",
      "model": "Estimated model",
      "price": "Old device price",
      "bonus": "Bonus",
      "reclaimFailure": "Due to your failure to send out the device within 10 days after it was received, the recycling order has timed out and been cancelled. If you still wish to complete the old device recycling, you can click the button below to check the latest quote.",
      "total": "Total price",
      "logisticInfo": "Logistics information",
      "available": "No logistics information available",
      "logisticNum": "Logistics number",
      "failRey": "We apologize that your participation in the OnePlus recycling program was not successfully completed. If you have a recycling plan for other electronic products, you can click the button below for a quick estimate!!",
      "userRes": "The user has already rejected the offer.",
      "successPrice": "The following price is after professional inspection. If you agree with this price, you can proceed with the trade-in. If you reject it, the device will be sent back to you in a few working days.",
      "sure": "Accept",
      "Reject": "Reject",
      "congratulation": "Congratulations QC No difference.",
      "finPirce": "Final price",
      "copySuccess": "Copy Success",
      "copyfail": "Copy Failure",
      "sureSuccess": "Confirm successful transaction",
      "submitError": "Submission failed",
      "detectionResult": "detection result",
      "Collected": "Place an order",
      "inTransit": "In transit",
      "656g0lj3sav6": "recycling process",
      "656g0lj3cd5a": "Correctly fill in your personal information and successfully place the order",
      "656g0lj3dr9a": "The inspection of your mobile phone will be completed within 48 hours of its arrival at our center",
      "656g0lj3epal": "Once the inspection is complete, we will contact you with a final offer via email",
      "656g0lj3pda2": "Your estimate",
      "656g0lj3ed3d": "Professional quality check",
      "656g0lj3esf3": "Copy",
      "expertDiscount": "promotion code",  // 推广码补贴
      "invalidCode": "invalidCode",
      "toastTip": "Check to accept Privacy Policy & Terms.",
      "649f8aef26sf": "Trade-in process",
      "checkTitle": "Testing information",
      "basicInformation": "Basic information",
      "understand": "I understand",
      '656g0lj3sf6e': 'Promotional bonuses are offered and managed by the associated brands. They will be paid separately and are not part of the valuation of the old device.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Refuse to recycle",
      "64a9shqq3k00": "You confirm that you refuse to recycle",
      "64a9shqq3r00": "Cancel Success",
      "64a9shqq3ws0": "Cancellation failed",
      "sureCancel": "Confirm cancel"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Who",
      "646u995lv9g0": "are we?",
      "646u9d5lv9g0": "Danghuan is a company with a core business focused on the recycling, disposal, and sale of 3C digital products such as mobiles, tablets, laptops, and watches. Our company is dedicated to accelerating the recycling efficiency of electronic products and promoting the healthy development of the second-hand market. Currently, we have established official strategic partnerships with OPPO, Vivo, OnePlus, Realme, and others. Our overseas business has expanded to India, Thailand, Vietnam, Cambodia, and now Europe.",
      "646u995dv9g0": "Our global presence has positioned us as a strategic partner for mobile operators, manufacturers, and wholesalers with both continental and transcontinental reach.",
      "646u99slv9g0": "We collaborate with leading manufacturers and maintain a diverse inventory that includes low, mid and high-end devices. This enables us to provide customized solutions and competitive pricing to meet the needs of our customers."
    },
    "business": {
      "646v04syvpk0": "Are you interested in purchasing our stock?",
      "646v04syxs80": "At Danghuan, we provide a comprehensive selection of mobile phones, tablets and smartwatches, and available across various grading levels to meet diverse business requirements.",
      "646v04syy6g0": "Contact our Sales&Purchase Manager :",
      "646v04syya80": "I Want To Buy",
      "646v04syydg0": "Enter Your Name",
      "646v04syyh40": "Enter Your Phone",
      "646v04syyyw0": "Enter Your Email",
      "646v0gsyz1s0": "Country:",
      "646v04syz1s0": "Please choose an option",
      "646v04syz4o0": "I have read and accept the",
      "646v04syzkc0": "Privacy Policy",
      "646v04syzok0": "Contact us",
      "646v04syzvo0": "Please enter your phone number",
      "646v04syzys0": "Please enter your email",
      "646v04sz01o0": "Please enter a valid email",
      "646v04sz04g0": "Please enter your name",
      "646v04sz0740": "Please tick the box to agree to the privacy policy",
      "646v04sz0a00": "Submission successful",
      "646v04sz0cw0": "Submission failed",
      "title1": "Transparent Mobile Grading",
      "text1-1": "To support your purchasing decisions, we encourage you to review our detailed Grading document. It outlines the aesthetic and functional standards of each grade, enabling you to make well-informed choices that align with your expectations.",
      "title2": "Exceptional Client Support",
      "text2-1": "We recognize the unique needs of each client, which is why our team of multilingual sales professionals is dedicated to delivering tailored and expert assistance.",
      "title3": "Commitment to Sustainable Technology",
      "text3-1": "We are committed to advancing global access to sustainable technology solutions, ensuring that our processes create value for all stakeholders involved.",
      "text3-2": "For further inquiries or to arrange a  trial order, please contact us. Our team is ready to assist you with professionalism and care."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Get Paid Quickly in Just 4 Steps",
      "s1": "First step",
      "s1t": "Pack your device so that it arrives in the same condition it was in when it was sent.",
      "s2": "The second step",
      "s2t": "Deliver your package at our Drop-Off Point.",
      "s3": "The third step",
      "s3t": "Let’s check out your device and get you a quote.",
      "s4": "Step four",
      "s4t": "Get paid fast."
    },
    "section3": {
      "646tmse2fbo0": "Smartphones",
      "646tmse2mv00": "Stay tuned",
      "section3-text2": 'Tablets',
      "section3-text4": 'Watches',
      "section3-text5": 'Others',
      "title": "Quick valuation",
      "t1": "Select the type and start valuation, get a fair quote.",
      "t2": "Simple steps, enjoy our quick recycling service !",
    },
    "section6": {
      "646txzpazuc0": "About Danghuan",
      "666txzpazuc0": "A company specializing in the recycling and reuse of smartphones, tablets and other digital devices,  dedicated to providing a simple, safe, and efficient service process, allowing every customer to easily achieve used device recycling. ",
      "646txzpb0rk0": "Details",
      "646txzpb0xc0": "Provide 12 Brands Recycling"
    },
    "section7": {
      "646ns2k5f7k0": "Our Service is always available",
      "646ns2k5gmw0": "Customer services: Monday to Friday from 9:00 to 18:00 CET (UTC+1:00) Madrid, Spain",
      "646ns2k5gs40": "Enter Your Name",
      "646ns2k5gx40": "Enter Your Phone",
      "646ns2k5img0": "Enter Your Email",
      "646ns2k5isw0": "Write us a message before we get in touch with you",
      "646ns2k5iws0": "Contact us",
      "646ns2k5j140": "Please enter your phone number",
      "646ns2k5j4g0": "Please enter your email",
      "646ds2k5j4g0": "Email",
      "646ns2k5j6c0": "Please enter a valid email",
      "646ns2k5j8g0": "Contact us",
      "646ns2k5jak0": "C.I.F :",
      "646ns2k5jck0": "Address",
      "646ns2s5jck0": "Calle Tomás Bretón, 46, Planta 1, Oficina 5, 28045 Madrid, España",
      "646ns2k5jgc0": "Please enter your name",
      "646ns2k5ji40": "Please tick the box to agree to the privacy policy",
      "646ns2k5jk00": "Submission successful",
      "646ns2k5jm80": "Submission failed",
      "646ny1rgz3c0": "I have read and accept the ",
      "646ny1rh2k40": "Privacy Policy"
    },
    "successMain": {
      "647qmd42l1s0": "Order received successfully!",
      "647qmd42mss0": "Please pay attention to the shipping instruction email sent to you from noreply@Danghuan.eu. If you have not received it, please check your SPAM folder or contact our customer service at support@Danghuan.es",
      "647qmd42mz80": "Our offer",
      "647qmd42yeo0": "Tips before shipping",
      "orderTime": "Order time",
      "text1": "Free shipping",
      "text2": "Please pay attention to the shipping document sent to your email.",
      "text3": "Data backup",
      "text4": "To protect your data, please back it up and delete all data or initialize the device.",
      "text5": "Charge",
      "text6": "Kindly charge your phone to 1% before shipping to help speed up the inspection."

    },
    "tradeInProcess": {
      "649f8aefats0": "Order Timeout",
      "649f8aefc1c0": "Recycling Failed",
      "649f8aefc9c0": "Get a New Quote",
      "TradeIn": "Trade-in process",
      "logistic": 'Download shipping label',
      "start": "Start Journey",
      "success": "You have successfully signed for the new machine",
      "qc": "Old Device QC",
      "business": "We will complete your old device inspection within 3 working days",
      "completed": "Completed",
      "successfully": "Congratulations your trade-in are successfully",
      "orderInfor": "Order information",
      "orderID": "Recycling order number",
      "orderNum": "New device purchase order ID",
      "createTime": "Creation time",
      "brand": "Estimated brand",
      "model": "model",
      "price": "Old device price",
      "bonus": "Bonus",
      "total": "Total price",
      "logisticInfo": "Logistics information",
      "available": "No logistics information available",
      "logisticNum": "Logistics number",
      "failRey": "We apologize that your participation in the OnePlus recycling program was not successfully completed. If you have a recycling plan for other electronic products, you can click the button below for a quick estimate!!",
      "userRes": "The user has already rejected the offer.",
      "successPrice": "The following price is after professional inspection. If you agree with this price, you can proceed with the trade-in. If you reject it, the device will be sent back to you in a few working days.",
      "sure": "Accept",
      "Reject": "Reject",
      "congratulation": "Congratulations QC No difference.",
      "finPirce": "Final price",
      "copySuccess": "Copy Success",
      "copyfail": "Copy Failure",
      "sureSuccess": "Confirm successful transaction",
      "submitError": "Submission failed",
      "detectionResult": "detection result",
      "Collected": "Collected",
      "inTransit": "In transit/Shipping",
      "understand": "I understand",
      "656g0lj3sf6e": "Promotional bonuses are offered and managed by the associated brands. They will be paid separately and are not part of the valuation of the old device."
    },
    "btnDialog": {
      "64a9shqq2ks0": "Refuse to recycle",
      "64a9shqq3k00": "You confirm that you refuse to recycle",
      "64a9shqq3r00": "Cancel Success",
      "64a9shqq3ws0": "Cancellation failed",
      "sureCancel": "Confirm cancel"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Personal information",
      "649fhwp9zbo0": "Upload clear photo of your package",
      "649fhwpa1900": "Download the shipping label",
      "649fhwpa1l00": "Download the shipping label",
      "649fhwpa1tc0": "Complete delivery",
      "649fhwpa2100": "Package Photo and Honesty Declaration",
      "649fhwpa2880": "Example of How to Place the Shipping Label",
      "649fhwpa2h80": "Note",
      "649fhwpa2qk0": "Packaging: Wrap the phone in bubble wrap and fill the box with newspaper to prevent damage during transport.",
      "649fhwpa2xs0": "Fill gaps with protective padding to prevent damage.",
      "649fhwpa3fk0": "Logistics Label: Bring the logistics label (digital or printed) to the drop-off point; the official label will be printed there.",
      "649fhwpa3v40": "Please send your used phone as soon as possible. If it is not shipped within 10 calendar days, the order will be canceled.",
      "649fhwpa42s0": "Delivery Points Inquiry",
      "649fhwpa4as0": "Download the Label",
      "649fhwpa4jo0": "Upload",
      "649fhwpa4ok0": "Home",
      "649fhwpa4to0": "Submit successfully",
      "649fhwpa4yk0": "Congratulations, download succeeded!",
      "649fhwpasf3s": "Attention",
      "649fhwpaa6f3": "Please print and sign the Honesty Declaration, then take a photo of it along with the old device package and upload it."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Social Media",
      "646d71qugz40": "Easy payment",
      "646u51qugz40": "Logistic",
      "646u5dqui780": "Privacy Policy",
      "646uddqui780": "Terms and Conditions",
      "646u51qui780": "FAQs"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "About Danghuan",
      "646ntjwmn580": "Business",
      "646nt7hwils0": "Contact us",
      "646nt7hwipg0": "Buy",
      "646nt7hwis00": "Sell"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Free Estimate"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Enter the model you want to sell",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "Sorry, the model not exist",
      "confirm": 'Confirm',
      "cancle": "Cancle",
      "dialogText": 'Are you sure to delete all history \n records?'
    }
  },
  "PCProduct": {
    "empty": "Sorry, the model not exist"
  },
  "PCBrandTab": {
    "index": "Brand"
  },
  "PCCategoryTab": {
    "index": "Categoty"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Order online",
      "646xagqwkuw0": "Free shipping",
      "646xagqwmao0": "Testing",
      "646xagqwmlc0": "Quick payment"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Home"
    }
  },
  "router": {
    "selectModel": "Models",
    "selectProperty": 'Device issues',
    "price": "Estimated price",
    "priceOrder": 'Place an order',
    "orderSuccess": "Order successfully"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Re-select model",
      "646ymq6ot0k0": "Reminder",
      "646ymq6pd100": "Before shipping, please make sure to log out of the cloud account",
      "646ymq6pekw0": "/screen lock/Apple ID on the old device."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Select device condition",
      "647h1f4yr6c0": "Estimated price",
      "647h1f4yso80": "Estimated Bonus",
      "text1": "Free shipping",
      "text2": "Ofrecemos un servicio de logística y envío gratuito",
      "text3": "Immediate payment",
      "text4": "We will make the payment within 1-2 business days once we have received your used device.",
      "64tve23zt0g0": "Free shipping and sales pack",
      "64tve23zup00": "Secure data erasure",
      "64tve23zuy40": "Not happy? Free returns",
      "64tve23zv7g0": "Payment will be arranged within 1-2 business days upon receipt of the device",
      "64tve23zvbg0": "Choose your delivery method",
      "64tve23zvf80": "You have 10 days to deliver your phone.",
      "64tve23zvjc0": "Get a free shipping label and send your phone",
      "64tve23zvms0": "Get a shipping label on your email",
      "64tve23zvqg0": "Note:",
      "64tve23zvyo0": "Due to shipping restrictions related to lithium batteries, do not send theohone if you have any reason to suspect the battery might be defective or faulty.",
      "64tve23zwak0": "We are not able to return any accessories or packaging sent with the device.",
      "64tve23zwgs0": "Next steps to sell your phone",
      "64tve23zwm80": "Fill in your contact details",
      "64tve23zwt00": "Prepare your phone for shipping",
      "64tve23zwwk0": "Your device will be checked upon arrival. If the information you've provided is inaccurate, we will send a new offer. You can accept the new offer or get your phone back for free."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话",
      "646ynp3uehw0": "Enter the IMEI number",
      "646ynp3uem40": "Dial *#06# on the keypad to check the phone's IMEI"
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "See the offer"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Reminder: The price of mobile phones and electronic products may decrease by up to 6%, so we recommend shipping your package as soon as possible.",
      "647hqss760c0": "I have read and agree to the",
      "647hqss764w0": "Privacy Policy",
      "647hqss76ac0": "Terms and conditions",
      "647hqss76dg0": "Submit",
      "647hqss76gw0": "Total price (Used device valuation)",
      "text1": 'Total',
      "text2": "Estimated price",
      "text3": "Estimated Bonus",
      "dialogTitle": "Notice",
      "dialogText": "Click the CONFIRM button and check your email to proceed with the next step",
      "dialogBtn": "CONFIRM",
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Order Information",
      "647kboa06ys0": "Name",
      "647kboa0d6v8": "Country Code",
      "647kboa078s0": "Tel.",
      "647kboa07d00": "Address",
      "647kboa07jk0": "Country",
      "647kboa07p80": "Please select",
      "647kboa08b40": "Post Code ",
      "647kboa08h00": "City",
      "647kboa08zc0": "Address",
      "647kboa09440": "Bank Information",
      "647kboa096w0": "Email verification",
      "647kboa09ao0": "Email",
      "647kboa09dk0": "Verification code",
      "647kboa09u40": "Enter",
      "647kboa09z80": "Send",
      "647kboa0ak00": "Email format error",
      "647kboa0aog0": "Sent successful",
      "send": "Sented",
      "submit": "Submit",
      "error": "Verification code error",
      "64jjt96fg400": "Please enter the verification code",
      "64jjt96fki00": "Please get the verification code",
      "idNumber": "Identity Card Number / ID Number",
      "declaration": "Declaration of Integrity",
      "download": "download",
      "647kboa0idc0": "Personal ID",
      "647kboa0idc1": "(the official identity number issued by your country, \n used for identification in legal, tax, or administrative procedures. \n This could be your DNI, NIE, Codice Fiscale, Personalausweisnummer, CNP, \n or another equivalent national document, depending on your country of residence.)",
      "647kboa0idc2": "(the official identity number issued by your country, \n used for identification in legal, \n tax, or administrative procedures. \n This could be your DNI, NIE,\n Codice Fiscale, Personalausweisnummer, CNP, \n or another equivalent national document,\n depending on your country of residence.)",
      "idError": "Invalid ID Number",
      "ibanTip": "Used to receive the payment for the old device.",
      "downloadDec": "Please download the Integrity Declaration.",
      "addreddPlaceholder": "This field supports up to 105 characters"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Homepage",
      "notRecyclable": "This type of device is not recyclable",
      "IKnow": "I see",
      "tips": "Tips"
    }
  },

  "blog": {
    "blogList": {
        "64wgr171lsk0": "Views",
        "64wgr171nq40": "No related content available.",
        "64wgr171av65": "Date"
    },
    "blogDetail": {
        "64wgr9y5r7s0": "Views",
        "64wgr171wdx9": "Details",
    }
  },

  "cookieNotice": {
    "title": "Cookie Notice",
    "description": "We use cookies to enhance your browsing experience. By continuing to use this website, you agree to our",
    "cookiePolicy": "Cookie Policy",
    "acceptAll": "Accept all cookies",
    "acceptNecessary": "Accept only necessary cookies",
    "customize": {
      "title": "Please select the types of cookies you wish to accept:",
      "necessary": {
        "label": "Necessary cookies",
        "description": "These cookies are essential for the website to function and cannot be disabled."
      },
      "analytics": {
        "label": "Analytics cookies",
        "description": "These cookies help us understand how visitors interact with our website."
      },
      "marketing": {
        "label": "Marketing cookies",
        "description": "These cookies track user activity across websites to deliver relevant ads."
      }
    },
    "save": "Save settings",
    "cancel": "Cancel"
  }
}
